import { Header, Button } from '@amzn/awsui-components-react';
import { Event, Shift, Source } from '@amzn/red-velvet-api';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { DISPLAY_ATTRIBUTES_TYPE, ShiftInfo } from '../../shifts/shiftInfo';
import { SpaLink } from '../../SpaLink';
import { EditEventBenevityLink } from '../../shifts/actions';
import { useUrlPage } from '../../../hooks/attendance/urlPage';
import { FIRST_PAGE } from '../wizard/attendanceWizard';
import { useUser } from '../../../hooks/user';
import { canManageGivehubEvent } from '../../../utils/shiftUtils';

interface ShiftHeaderProps {
  event: Event;
  manageSignup?: boolean;
}

export function ShiftHeader(props: ShiftHeaderProps) {
  const namespaces = ['attendance', 'translation'];
  const { t } = useTranslation(namespaces);
  const users = useUser();

  const { event, manageSignup = false } = props;
  const analyticsPrefix = manageSignup ? 'manageSignup' : 'trackAttendance';
  const [searchParams] = useSearchParams();
  const selectedTimezone = searchParams.get('timezone');
  const urlFeatures = searchParams.get('features');
  const viewDetailsUrl = `/view-event?id=${event.eventId}${selectedTimezone ? '&timezone=' + selectedTimezone : ''}${urlFeatures ? '&features=' + urlFeatures : ''}`;
  const { setPage } = useUrlPage(FIRST_PAGE);

  return (
    <Header
      actions={
        canManageGivehubEvent(event, users) ? (
          <EditEventBenevityLink event={event} />
        ) : (
          <Button
            data-aci-analytics-name={`${analyticsPrefix}_editEvent`}
            onClick={() => setPage(0)}
          >
            {t('attendanceHeader.editEvent')}
          </Button>
        )
      }
    >
      {event.source === Source.GIVEHUB ? (
        <SpaLink data-aci-analytics-name={`${analyticsPrefix}_title`} href={viewDetailsUrl}>
          <h2>{event.title}</h2>
        </SpaLink>
      ) : (
        <h2>{event.title}</h2>
      )}
    </Header>
  );
}
interface ShiftCardProps {
  event: Event;
  shift: Shift;
  displayAttributes: DISPLAY_ATTRIBUTES_TYPE[];
}

export function ShiftCard({ event, shift, displayAttributes }: ShiftCardProps) {
  return <ShiftInfo event={event} shift={shift} displayAttributes={displayAttributes} />;
}
